import { createSelector, } from "reselect";

export const appTypeState = (state, props) => {
  return state.login.get("appType");
};

export const appTypeSelector = () =>
  createSelector([appTypeState,], appType => appType);

const appValidState = (state, props) => {
  return state.login.get("appValid");
};

export const appValidSelector = () =>
  createSelector([appValidState,], appValid => appValid);

const sebConfigFileState = (state, props) => {
  return state.login.get("seb_config_file");
};

export const sebConfigFileSelector = () =>
  createSelector([sebConfigFileState,], sebConfigFile => sebConfigFile);

export const sebConfigFileLoadingState = (state) =>
  state.login.get("sebloading", false);

export const sebConfigFileLoadingSelector = () =>
  createSelector([sebConfigFileLoadingState], (sebloading) => sebloading);


const changeSecurityState = (state) => {
  return state.offlineApp.get("changeSecurity");
};

const appUrlState = (state) => {
  return state.offlineApp.get("setAppUrl");
};

export const appEnvTypeSelector = () =>
  createSelector([appUrlState,], appEnvUrl => appEnvUrl);

export const changeSecurityStatusSelector = () =>
  createSelector([changeSecurityState,], securityStatus => securityStatus);
